import { type IApiResponse, type IGetResultSubscriptionTypeByID, type IResultSubscription } from '@/helpers/types';
import { getCommandQuery, type IGetQuery } from '@/store/actions/api-utils';
import {
	type ICreateResultSubscription,
	type IRemoveEmailSubscription,
	type ISubscriptionAddEmails,
	type IUnsubscribeResultSubscription,
} from '@/store/actions/core/subscription';

import { coreApiSlice } from '../apiSlice';

const subscriptionApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		creatSubscription: builder.mutation<IApiResponse, ICreateResultSubscription>({
			query: (body) => ({
				method: 'POST',
				url: '/ResultSubscription',
				body,
			}),
		}),
		getSubscription: builder.query<IApiResponse<IResultSubscription[]>, IGetQuery<IResultSubscription>>({
			query: ({ paged, query }) => ({
				url: `/ResultSubscription${getCommandQuery(paged, ...(query || []))}`,
			}),
		}),
		getSubscriptionByElection: builder.query<IApiResponse, { electionId: string }>({
			query: ({ electionId }) => ({
				url: `/ResultSubscription/election/${electionId}`,
			}),
		}),
		getSubscriptionById: builder.query<IApiResponse, { id: string }>({
			query: ({ id }) => ({
				url: `/ResultSubscription/${id}`,
			}),
		}),
		getSubscriptionDocumentTypeEmails: builder.query<IApiResponse, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/ResultSubscription/document-type-emails${getCommandQuery(paged, ...(query || []))}`,
			}),
		}),
		unsubscribeScription: builder.mutation<IApiResponse, IUnsubscribeResultSubscription>({
			query: (body) => ({
				method: 'POST',
				url: '/ResultSubscription/unsubscribe',
				body,
			}),
		}),
		addEmailsSubscription: builder.mutation<IApiResponse, ISubscriptionAddEmails>({
			query: (body) => ({
				url: '/ResultSubscription/add-emails',
				method: 'POST',
				body,
			}),
		}),
		removeEmailsSubscription: builder.mutation<IApiResponse, IRemoveEmailSubscription>({
			query: (body) => ({
				url: '/ResultSubscription/unsubscribe',
				method: 'POST',
				body,
			}),
		}),
		getSubscriptionType: builder.query<IApiResponse, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/ResultSubscriptionTypes${getCommandQuery(paged, ...(query || []))}`,
			}),
		}),
		getSubscriptionTypeById: builder.query<IGetResultSubscriptionTypeByID, { id: string }>({
			query: ({ id }) => ({
				url: `/ResultSubscriptionTypes/${id}`,
			}),
		}),
	}),
});

export const {
	useAddEmailsSubscriptionMutation,
	useCreatSubscriptionMutation,
	useGetSubscriptionByElectionQuery,
	useGetSubscriptionByIdQuery,
	useGetSubscriptionDocumentTypeEmailsQuery,
	useGetSubscriptionQuery,
	useLazyGetSubscriptionQuery,
	useGetSubscriptionTypeByIdQuery,
	useGetSubscriptionTypeQuery,
	useRemoveEmailsSubscriptionMutation,
	useUnsubscribeScriptionMutation,
} = subscriptionApiSlice;
